import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomFileUploaderComponent } from './custom-file-uploader.component';




@NgModule({
  declarations: [
    CustomFileUploaderComponent
  ],
  imports: [
    CommonModule,
    //UploaderModule
  ],
  exports: [
    CustomFileUploaderComponent
  ],
})
export class CustomFileUploaderModule { }
